var isMobile = /mobile/i.test(window.navigator.userAgent);
var utils = {
    secondToTime: function secondToTime(second) {
        var showHour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        second = second || 0;
        if (second === 0 || second === Infinity || second.toString() === 'NaN') {
            return '00:00';
        }
        var add0 = function add0(num) {
            return num < 10 ? '0' + num : '' + num;
        };
        var hour = Math.floor(second / 3600);
        var min = Math.floor((second - hour * 3600) / 60);
        var sec = Math.floor(second - hour * 3600 - min * 60);
        if (showHour) {
            return (hour > 0 ? [
                hour,
                min,
                sec
            ] : [
                min,
                sec
            ]).map(add0).join(':');
        } else {
            return [
                hour * 60 + min,
                sec
            ].map(add0).join(':');
        }
    },
    debounce: function debounce() {
        var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        };
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
        var timer;
        return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }
            var event = args[args.length - 1];
            if (timer) {
                clearTimeout(timer);
            }
            if (event && typeof event.persist === 'function') {
                event.persist();
            }
            var _this = this;
            timer = setTimeout(function () {
                fn.apply(_this, args);
                clearTimeout(timer);
                timer = null;
            }, delay);
        };
    },
    throttle: function throttle(fn, wait) {
        var timer = null;
        return function () {
            var context = this;
            var args = arguments;
            if (!timer) {
                timer = setTimeout(function () {
                    fn.apply(context, args);
                    clearTimeout(timer);
                    timer = null;
                }, wait);
            }
        };
    },
    textToSecond: function textToSecond(str) {
        var arr = str.split(/[:：]/).slice(-3);
        var sec = parseInt(arr[arr.length - 1]);
        var min = parseInt(arr[arr.length - 2]);
        var hour = parseInt(arr[arr.length - 3]);
        sec = sec ? sec : 0;
        min = min ? min : 0;
        hour = hour ? hour : 0;
        return sec + min * 60 + hour * 3600;
    },
    getElementViewLeft: function getElementViewLeft(element) {
        var actualLeft = element.offsetLeft;
        var current = element.offsetParent;
        var elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
            while (current !== null) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        } else {
            while (current !== null && current !== element) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        }
        return actualLeft - elementScrollLeft;
    },
    getElementViewTop: function getElementViewTop(element) {
        var actualTop = element.offsetTop;
        var current = element.offsetParent;
        var elementScrollTop = document.body.scrollTop + document.documentElement.scrollTop;
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
            while (current !== null) {
                actualTop += current.offsetTop;
                current = current.offsetParent;
            }
            return actualTop - elementScrollTop;
        } else {
            while (current !== null && current !== element) {
                actualTop += current.offsetTop;
                current = current.offsetParent;
            }
            return actualTop;
        }
    },
    getBoundingClientRectViewLeft: function getBoundingClientRectViewLeft(element) {
        var scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        if (element.getBoundingClientRect) {
            if (typeof this.getBoundingClientRectViewLeft.offset !== 'number') {
                var temp = document.createElement('div');
                temp.style.cssText = 'position:absolute;top:0;left:0;';
                document.body.appendChild(temp);
                this.getBoundingClientRectViewLeft.offset = -temp.getBoundingClientRect().top - scrollTop;
                document.body.removeChild(temp);
                temp = null;
            }
            var rect = element.getBoundingClientRect();
            var offset = this.getBoundingClientRectViewLeft.offset;
            return rect.left + offset;
        } else {
            return this.getElementViewLeft(element);
        }
    },
    getScrollPosition: function getScrollPosition() {
        return {
            left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
            top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        };
    },
    setScrollPosition: function setScrollPosition(_ref) {
        var _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top;
        if (this.isFirefox) {
            document.documentElement.scrollLeft = left;
            document.documentElement.scrollTop = top;
        } else {
            window.scrollTo(left, top);
        }
    },
    isFirefox: /firefox/i.test(window.navigator.userAgent),
    isChrome: /chrome/i.test(window.navigator.userAgent),
    createArray: function createArray(count, val) {
        return Array.from({ length: count }, function (_, k) {
            return k;
        }).map(function () {
            return val;
        });
    },
    storage: {
        set: function set(key, value) {
            localStorage.setItem(key, value);
        },
        get: function get(key) {
            return localStorage.getItem(key);
        }
    },
    nameMap: {
        dragStart: isMobile ? 'touchstart' : 'mousedown',
        dragMove: isMobile ? 'touchmove' : 'mousemove',
        dragEnd: isMobile ? 'touchend' : 'mouseup'
    },
    colorLuminance: function colorLuminance(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;
        var rgb = '#', c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
            rgb += ('00' + c).substr(c.length);
        }
        return rgb;
    },
    hex2Rgb: function hex2Rgb(str, opacity) {
        var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
        if (!reg.test(str)) {
            return;
        }
        var newStr = str.toLowerCase().replace(/\#/g, '');
        var len = newStr.length;
        if (len == 3) {
            var t = '';
            for (var i = 0; i < len; i++) {
                t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
            }
            newStr = t;
        }
        var arr = [];
        for (var i = 0; i < 6; i = i + 2) {
            var s = newStr.slice(i, i + 2);
            arr.push(parseInt('0x' + s));
        }
        if (opacity)
            return 'rgba(' + arr.join(',') + ',' + opacity + ')';
        return 'rgb(' + arr.join(',') + ')';
    },
    rgb2Hex: function rgb2Hex(str) {
        var reg = /^(rgb|RGB)/;
        if (!reg.test(str)) {
            return;
        }
        var arr = str.slice(4, str.length - 1).split(',');
        var color = '#';
        for (var i = 0; i < arr.length; i++) {
            var t = Number(arr[i]).toString(16);
            if (t == '0') {
                t = t + '0';
            }
            color += t;
        }
        return color;
    },
    color2Number: function color2Number(color) {
        if (color[0] === '#') {
            color = color.substr(1);
        }
        if (color.length === 3) {
            color = ''.concat(color[0]).concat(color[0]).concat(color[1]).concat(color[1]).concat(color[2]).concat(color[2]);
        }
        return parseInt(color, 16) + 0 & 16777215;
    },
    number2Color: function number2Color(number) {
        return '#' + ('00000' + number.toString(16)).slice(-6);
    },
    danmakuSpeed2Number: function danmakuSpeed2Number(speed) {
        switch (speed) {
        case '极慢':
            return 0.5;
        case '较慢':
            return 0.75;
        case '适中':
            return 1;
        case '较快':
            return 1.25;
        case '极快':
            return 1.5;
        default:
            return 1;
        }
    },
    number2danmakuSpeed: function number2danmakuSpeed(number) {
        switch (number) {
        case 0.5:
            return '极慢';
        case 0.75:
            return '较慢';
        case 1:
            return '适中';
        case 1.25:
            return '较快';
        case 1.5:
            return '极快';
        default:
            return '适中';
        }
    },
    number2Type: function number2Type(number, biliMode) {
        switch (number) {
        case 0:
            return 'right';
        case 1:
            return biliMode ? 'right' : 'top';
        case 2:
            return 'bottom';
        case 3:
            return 'left';
        case 4:
            return 'bottom';
        case 5:
            return 'top';
        case 6:
            return 'left';
        case 7:
            return 'special';
        case 8:
            return 'script';
        case 9:
            return 'json';
        default:
            return 'right';
        }
    },
    type2Number: function type2Number(type) {
        switch (type) {
        case 'right':
            return 0;
        case 'top':
            return 1;
        case 'bottom':
            return 2;
        case 'left':
            return 3;
        case 'special':
            return 7;
        case 'script':
            return 8;
        case 'json':
            return 9;
        default:
            return 0;
        }
    },
    report2Num: new Map([
        [
            '违法违禁',
            0
        ],
        [
            '人身攻击',
            1
        ],
        [
            '色情低俗',
            2
        ],
        [
            '政治敏感',
            3
        ],
        [
            '恶意刷屏',
            4
        ],
        [
            '引战',
            5
        ],
        [
            '侵犯隐私',
            6
        ],
        [
            '垃圾广告',
            7
        ],
        [
            '其他',
            8
        ]
    ]),
    initHash: function initHash() {
        var count = 100;
        return function (hashLength) {
            if (!hashLength || typeof Number(hashLength) != 'number') {
                return;
            }
            var ar = [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '0',
                'a',
                'b',
                'c',
                'd',
                'e',
                'f',
                'g',
                'h',
                'i',
                'j',
                'k',
                'l',
                'm',
                'n',
                'o',
                'p',
                'q',
                'r',
                's',
                't',
                'u',
                'v',
                'w',
                'x',
                'y',
                'z'
            ];
            var hs = [];
            var hl = Number(hashLength);
            var al = ar.length;
            for (var i = 0; i < hl; i++) {
                hs.push(ar[Math.floor(Math.random() * al)]);
            }
            count++;
            return hs.join('') + ''.concat(count);
        };
    },
    randomFontsize: function randomFontsize(range) {
        var allSize = [
            16,
            18,
            25,
            36,
            45,
            64
        ];
        var random = Math.floor(Math.random() * range);
        return allSize[random];
    },
    formatterDate: function formatterDate(date, pattern) {
        Date.prototype.format = function (fmt) {
            var o = {
                'M+': this.getMonth() + 1,
                'D+': this.getDate(),
                'H+': this.getHours(),
                'm+': this.getMinutes(),
                's+': this.getSeconds(),
                'q+': Math.floor((this.getMonth() + 3) / 3),
                S: this.getMilliseconds()
            };
            if (/(Y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
                }
            }
            return fmt;
        };
        var ts = date.getTime();
        var d = new Date(ts).format('YYYY-MM-DD HH:mm:ss');
        if (pattern) {
            d = new Date(ts).format(pattern);
        }
        return d.toLocaleString();
    }
};
export default utils;